import { SvgIcon } from '@mui/material';

export function CircleCheck({ size = 18, sx = {}, ...props }) {
	return (
		<SvgIcon
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			sx={{ ...sx, fontSize: size }}
			{...props}
		>
			<path
				d="M7.83366 12.8337L13.7087 6.95866L12.542 5.79199L7.83366 10.5003L5.45866 8.12533L4.29199 9.29199L7.83366 12.8337ZM9.00033 17.3337C7.84755 17.3337 6.76421 17.1149 5.75033 16.6774C4.73644 16.2399 3.85449 15.6462 3.10449 14.8962C2.35449 14.1462 1.76074 13.2642 1.32324 12.2503C0.885742 11.2364 0.666992 10.1531 0.666992 9.00033C0.666992 7.84755 0.885742 6.76421 1.32324 5.75033C1.76074 4.73644 2.35449 3.85449 3.10449 3.10449C3.85449 2.35449 4.73644 1.76074 5.75033 1.32324C6.76421 0.885742 7.84755 0.666992 9.00033 0.666992C10.1531 0.666992 11.2364 0.885742 12.2503 1.32324C13.2642 1.76074 14.1462 2.35449 14.8962 3.10449C15.6462 3.85449 16.2399 4.73644 16.6774 5.75033C17.1149 6.76421 17.3337 7.84755 17.3337 9.00033C17.3337 10.1531 17.1149 11.2364 16.6774 12.2503C16.2399 13.2642 15.6462 14.1462 14.8962 14.8962C14.1462 15.6462 13.2642 16.2399 12.2503 16.6774C11.2364 17.1149 10.1531 17.3337 9.00033 17.3337ZM9.00033 15.667C10.8614 15.667 12.4378 15.0212 13.7295 13.7295C15.0212 12.4378 15.667 10.8614 15.667 9.00033C15.667 7.13921 15.0212 5.56283 13.7295 4.27116C12.4378 2.97949 10.8614 2.33366 9.00033 2.33366C7.13921 2.33366 5.56283 2.97949 4.27116 4.27116C2.97949 5.56283 2.33366 7.13921 2.33366 9.00033C2.33366 10.8614 2.97949 12.4378 4.27116 13.7295C5.56283 15.0212 7.13921 15.667 9.00033 15.667Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
